import { Button } from '@material-ui/core';
import React from 'react';

export const ButtonColumn = (value, row, rowIndex, { onSend, disabled=false }) => {
	
	return (
		<>
			<Button disabled={disabled} onClick={() => onSend(row)} className="btn btn-primary">
				Enviar
			</Button>
		</>
	);
};
